export const TOOLTIP_LABELS = [
  'at least 1 lowercase letter',
  'at least 1 uppercase letter',
  'at least 1 number',
  'at least 1 special character',
  'at least 8 characters',
  'maximum 255 characters',
];
